export const codeLoop = `
qqq = 15
for i in range(1000000):
    qqq+=1
`